"use client";

import Link from "next/link";
import { useEffect, useState, Fragment } from "react";
import { useQueryState, parseAsInteger, createSerializer } from "nuqs";
import { cn } from "@/lib/utils";

import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuItem,
  DropdownMenuContent,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { getEventCategories } from "./actions";
import type { EventCategory } from "@/lib/schema/event";

const Filter = () => {
  const [eventCategoryId] = useQueryState("eventCategoryId", parseAsInteger);
  const [categories, setCategories] = useState<EventCategory[] | null>([]);

  useEffect(() => {
    const fetchData = async () => {
      const data = await getEventCategories();
      setCategories(data);
    };
    fetchData();
  }, []);

  const filters = [
    {
      id: "eventCategoryId",
      name: "Kategorie",
      options: categories?.map(({ id, name }) => ({
        label: name,
        value: id,
        current: id === eventCategoryId,
      })),
    },
  ];

  const searchParams = {
    eventCategoryId: parseAsInteger,
  };

  const serialize = createSerializer(searchParams);

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="outline">Filter</Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent className="w-56">
        {filters.map((section) => (
          <Fragment key={section.id}>
            <DropdownMenuLabel>{section.name}</DropdownMenuLabel>
            <DropdownMenuSeparator />

            {section.options?.map((option) => (
              <DropdownMenuItem
                key={option.value}
                className={cn("p-2", {
                  ["bg-brand-primary-sun text-black hover:text-inherit"]:
                    option.value === eventCategoryId,
                })}
              >
                <Link
                  href={serialize("/calendar", {
                    eventCategoryId: option.current ? null : option.value,
                  })}
                  className="text-sm font-medium whitespace-nowrap"
                >
                  {option.label}
                </Link>
              </DropdownMenuItem>
            ))}
          </Fragment>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export { Filter };
